import React from "react";
import {Helmet} from "react-helmet-async";
import styles from "../../styles/TextPages.module.css";
import logo from "../../assets/pokerly-logo-purple.svg";
import BurgerMenu from "../../components/common/BurgerMenu/BurgerMenu";
import footerBg from "../../assets/footer-bg.svg";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const Contacts: React.FC = () => {
    const {t} = useTranslation();
    return (
        <>
            <Helmet>
                <title></title>
                <meta name="description" content={''}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={`https://pokerly.ru/contacts`}/>
                <meta property="og:title" content={''}/>
                <meta property="og:description" content={''}/>
                <meta property="og:image" content="https://pokerly.ru/og-image.png"/>
            </Helmet>
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.backToVoting}>
                        ← <span>{t("backToVoting")}</span>
                    </div>
                    <div className={styles.logo}>
                        <Link to="/"><img src={logo} alt="Logo"/></Link>
                    </div>
                    <BurgerMenu/>
                </div>
                <div className={styles.main}>
                    <h1 className={styles.title}>
                        {t("contactPageTitle")}
                    </h1>
                    <p>{t("contactPage1")}</p>
                    <div className={styles.contactWrp}>
                        <p>
                            {t("contactPage2")}
                        </p>
                        <div className={styles.contactList}>
                            <div className={styles.contactItem}>
                                <p className={styles.contactName}>
                                    📢 <a href='https://t.me/+KbSzCGZMGLJjYTdi'>{t("contactPageTg")}</a>
                                </p>
                                <p>
                                    {t("contactPageTgDsc")}
                                </p>
                            </div>
                            <div className={styles.contactItem}>
                                <p className={styles.contactName}>
                                    💬 <a href='https://t.me/+OGqg1D14vFFjMjNi'>{t("contactPageChat")}</a>
                                </p>
                                <p>
                                    {t("contactPageChatDsc")}
                                </p>
                            </div>
                            <div className={styles.contactItem}>
                                <p className={styles.contactName}>
                                    💼 <a href='#'>{t("contactPageLinkedin")}</a>
                                </p>
                                <p>
                                    {t("contactPageLinkedinDsc")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.footer}>
                    <img src={footerBg}/>
                    <div className={styles.footerContent}>
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.6894 3.63159C18.3967 2.94165 17.9576 2.32698 17.3722 1.78757C16.7995 1.23562 16.0677 0.802838 15.1768 0.48923C14.2986 0.163077 13.2678 0 12.0842 0H0V14.1124H7.94156V11.7227H7.96065L7.97974 11.7039H12.0842C13.2423 11.7039 14.2604 11.5471 15.1386 11.2335C16.0168 10.9073 16.7486 10.4683 17.334 9.91631C17.9321 9.36435 18.3776 8.73714 18.6703 8.03465C18.9758 7.31963 19.1285 6.56697 19.1285 5.77667C19.1285 5.03655 18.9821 4.32153 18.6894 3.63159ZM7.95174 9.47349L7.94156 9.49482L7.93011 9.47349C7.22504 7.99075 5.13784 7.42751 5.13784 5.83438C5.13784 4.4131 7.14995 3.85739 7.94156 5.28995C8.7319 3.85739 10.744 4.4131 10.744 5.83438C10.744 7.42751 8.65681 7.99075 7.95174 9.47349Z"
                                fill="#9B9B9B"/>
                        </svg>
                        <p>
                            {t("footerDescription")}
                        </p>
                    </div>
                    <p className={styles.copyright}>
                        2026 © Made with ❤️ from us. All rights reserved.
                    </p>
                </div>
            </div>
        </>
    );
};

// @ts-ignore
export default Contacts;